export default "__VITE_ASSET__CHTG5D8I__"